<script>
import SJanela from "../SJanela.vue";
import SForeigninput from "../SForeigninput.vue";

export default {
  name: "s-clientes-planos",
  components: { SForeigninput, SJanela },

  inject: ["hdl"],

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    cliente: {
      type: [Number, String],
    },
    hideUsuarios: {
      type: Boolean,
      default: false,
    },
    hideInput: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      idItem: null,
      basePath: Siggma.basePath,
      tipoPlano: "mensal",
      itemSelecionado: null,
    };
  },

  computed: {
    planos: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val, this.cliente);
      },
    },
  },

  methods: {
    itemAutocomplete() {
      return Siggma.autocompleteItem();
    },

    itemChange(doc) {
      this.itemSelecionado = doc;
    },

    remover(index) {
      const tc = Yanda.confirm(
        true,
        1,
        "Confirmação",
        "Tem certeza que deseja remover?",
        1,
      );
      tc.onBeforeClose = () => {
        if (tc.returnValue) {
          this.planos = this.planos.filter((_, i) => i !== index);
        }
      };
    },

    add() {
      if (!this.itemSelecionado) {
        Notify.warning("Informe um item");
        return;
      }

      const tipo = this.tipoPlano.charAt(0).toUpperCase() +
        this.tipoPlano.slice(1);
      const valor = this.tipoPlano === "mensal"
        ? this.itemSelecionado.proValVen
        : (this.itemSelecionado.extra
          ? this.itemSelecionado.extra[`valor${tipo}`]
          : 0);

      const novo = {
        tipo: this.tipoPlano,
        item: this.idItem,
        valorOriginal: valor,
        valor: null,
        descricao: this.itemSelecionado.proNom,
        diaVencimento: "",
        quantidadeUsuarios: "",
        inicio: null,
      };

      this.planos = [...this.planos, novo];
      this.tipoPlano = "mensal";
      this.idItem = null;
      this.itemSelecionado = null;
    },

    preventDefault(e) {
      (e.keyCode === 13 || e.keyCode === 10) && e.preventDefault();
    },
  },

  watch: {
    tipoPlano() {
      this.idItem = null;
    },
    planos: {
      immediate: true,
      handler(val) {
        val.forEach((o) => {
          if (!o.item.proCodOri) {
            return;
          }
          const tipo = o.tipo.charAt(0).toUpperCase() + o.tipo.slice(1);
          o.valorOriginal = (o.tipo === "mensal")
            ? o.item.proValVen
            : (o.item.extra ? o.item.extra[`valor${tipo}`] : 0);
          o.descricao = o.item.proNom;
          o.item = o.item.proCodOri;
          o.lbValor = "Valor:";
          o.active = true;
        });
      },
    },
    hideInput(value, oldValue) {
      if (value && !oldValue) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.itemInput?.$el?.focus?.();
      });
    },
  },

  updated() {
    const inputs = this.$refs.root.querySelectorAll("input:not([type=hidden])");
    inputs.forEach((ipt) => {
      if (!ipt.dataset.kp) {
        ipt.dataset.kp = true;
        jQuery(ipt).on("keypress", this.preventDefault);
      }
    });
  },
};
</script>

<template>
  <div class="clientes-planos" ref="root">
    <div class="clientes-planos-input" v-if="!hideInput">
      <div>
        <label>Tipo:</label>
        <select v-model="tipoPlano" style="width: 120px;">
          <option value="mensal">Mensal</option>
          <option value="bimestral">Bimestral</option>
          <option value="trimestral">Trimestral</option>
          <option value="semestral">Semestral</option>
          <option value="anual">Anual</option>
        </select>
      </div>
      <div style="flex: 1">
        <div style="display:flex;align-items: center;margin: 0 40px">
          <label>Item/Serviço:</label>
          <s-foreigninput ref="itemInput" style="display: inline-block;flex:1"
            v-model="idItem" :url="`${basePath}/app/itens/get-by-codigo`"
            :tela="89" :number="false" field-cod="proCodOri" field-des="proNom"
            @change="itemChange"
            field-cod-style="width: 200px; text-align: right;"
            :autocomplete="itemAutocomplete()"></s-foreigninput>
        </div>
      </div>
      <button type="button" @click="add" class="btn-small">
        <i class="mdi mdi-plus mdi-18px"></i>
      </button>
    </div>
    <div class="clientes-planos-table">
      <div v-if="!planos.length" style="margin: 50px auto; text-align: center">
        <label style="font-size: 20px;">Nenhum plano foi registrado</label>
      </div>
      <div v-for="(l, index) in planos" class="clientes-planos-item"
        :key="`item-${index}`">
        <div style="width: 55px;text-align: center">
          <span class="s-tag">{{ l.tipo }}</span>
        </div>
        <div style="flex: 1" v-html="l.descricao"></div>
        <div>
          <i style="cursor:pointer"
            :class="`mdi mdi-${l.valor === null ? 'lock-outline' : 'lock-open-variant-outline'} ${hideUsuarios ? '' : 'mdi-18px'}`"
            @click="l.valor = l.valor === null ? l.valorOriginal : null"></i>
          <label>Valor:</label>
          <s-numberinput v-if="l.valor === null" v-model="l.valorOriginal"
            style="width: 90px;text-align: right;" disabled></s-numberinput>
          <s-numberinput v-else v-model="l.valor"
            style="width: 90px;text-align: right;"></s-numberinput>
        </div>
        <div>
          Início:
          <s-datetimepicker type="month" v-model="l.inicio"
            style="width:80px;text-align:center"></s-datetimepicker>
        </div>
        <div>
          Dia vencimento:
          <s-numberinput v-model="l.diaVencimento"
            style="width: 50px;text-align: center;" :decimals="0" maxlength="2"
            :max="31"></s-numberinput>
        </div>
        <div v-if="!hideUsuarios">
          Usuários:
          <s-numberinput v-model="l.quantidadeUsuarios"
            style="width: 50px;text-align: center;" :decimals="0"
            maxlength="3"></s-numberinput>
        </div>
        <button type="button" class="btn-small" style="margin: 0  0 0 10px;"
          @click.stop="remover(index)">
          <i class="mdi mdi-trash-can mdi-18px"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.clientes-planos {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.clientes-planos-input {
  padding: 10px;
  display: flex;
  align-items: center;
}

.clientes-planos-table {
  overflow-y: auto;
  flex: 1;
  border: 1px solid #aaa;
  border-radius: 8px;
  padding: 5px 0;
}

.clientes-planos .el-row {
  min-height: 36px;
  display: flex;
  align-items: center;
}

.clientes-planos .el-tag {
  margin: 0 3px;
}

.clientes-planos-item {
  display: flex;
  flex-flow: row nowrap;
  position: relative;
  align-items: center;
  width: calc(100% - 20px);
  min-height: 36px;
  max-width: 1200px;
  margin: 0 auto 2px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 1px 3px #c1c1c1;
  transition: margin .5s;
  cursor: pointer;

  &:hover {
    background-color: whitesmoke;
  }
}

.clientes-planos-item>div {
  font-size: 12px;
  margin: 0 4px;
}
</style>